import React, {useState} from "react";
import styled from "styled-components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

/* Data ---------------------------*/
import Data2020 from '../assets/data/2020data';
import Data2021 from '../assets/data/2021data';
import Data2022 from '../assets/data/2022data';
import Data2023 from '../assets/data/2023data';
import Data2024 from '../assets/data/2024data';
import Data2025 from '../assets/data/2025data';
import { tableSelect } from "../assets/data/selectData";

/* Components ---------------------------*/
import TaxTable from "../components/TaxTable/TaxTable";
import SelectButton from "../components/SelectButton/SelectButton";
import StandardDeduction from "../components/MiscTables/StandardDeduction";

const California = () => {

    const [ selectedButton, selectedButtonUpdate ] = useState(tableSelect[2]);

    const isMobile = navigator.maxTouchPoints > 0 ? 'mview' : 'dview';
    return (
        <CaliforniaStyled className="CaliforniaStyled">
            <Container fluid className="g-0 mb-0">
                <div className="row g-0">
                    <div className="cali-image">
                            <h1>CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                    </div>
                </div>
                <Tabs defaultIndex={0}>
                    <div className="listParent">
                        <TabList>
                            <Tab><strong>2025</strong></Tab>
                            <Tab><strong>2024</strong></Tab>
                            <Tab><strong>2023</strong></Tab>
                            <Tab><strong>2022</strong></Tab>
                            <Tab><strong>2021</strong></Tab>
                            <Tab><strong>2020</strong></Tab>
                        </TabList>
                    </div>
                    <Container>
                        <TabPanel>
                        <h1 className='taxYear'>2025 CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                        <p className={`Instructions ${ isMobile }`}><em>The buttons below allow you to select a single cell, row, or the entire table and copy it to your clipboard.</em></p>
                          <div className="buttonGroup">
                            <SelectButton selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } tableSelect={ tableSelect } />
                              <a href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2026+Court+Cases/2025+Federal-California-Desk-Reference.pdf" target="blank">
                                  <Button type='submit' className='SelectButton'><FontAwesomeIcon icon={faDownload}/> Download PDF</Button>
                              </a>
                            </div>
                          <TaxTable title='Single/Married Filing Separate' data={ Data2025.State.California.Single } hover= { selectedButton.name } />
                          <TaxTable title='Married Filing Joint' data={ Data2025.State.California.Married_Filing_Jointly } hover= { selectedButton.name } />
                          <TaxTable title='Unmarried Head of Household' data={ Data2025.State.California.Unmarried_Head_of_Household } hover= { selectedButton.name } />
                          <StandardDeduction data={ Data2025.State.California.Standard_Deduction } />
                      </TabPanel>
                    <TabPanel>
                        <h1 className='taxYear'>2024 CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                        <p className={`Instructions ${ isMobile }`}><em>The buttons below allow you to select a single cell, row, or the entire table and copy it to your clipboard.</em></p>
                          <div className="buttonGroup">
                            <SelectButton selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } tableSelect={ tableSelect } />
                              <a href="https://www.westerncpe.com/wp-content/uploads/2024/11/2024-FEDERAL-TAX-RATE-SCHEDULES.pdf" target="blank">
                                  <Button type='submit' className='SelectButton'><FontAwesomeIcon icon={faDownload}/> Download PDF</Button>
                              </a>
                            </div>
                          <TaxTable title='Single/Married Filing Separate' data={ Data2024.State.California.Single } hover= { selectedButton.name } />
                          <TaxTable title='Married Filing Joint' data={ Data2024.State.California.Married_Filing_Jointly } hover= { selectedButton.name } />
                          <TaxTable title='Unmarried Head of Household' data={ Data2024.State.California.Unmarried_Head_of_Household } hover= { selectedButton.name } />
                          <StandardDeduction data={ Data2024.State.California.Standard_Deduction } />
                      </TabPanel>
                      <TabPanel>
                          <h1 className='taxYear'>2023 CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                          <p className={`Instructions ${ isMobile }`}><em>The buttons below allow you to select a single cell, row, or the entire table and copy it to your clipboard.</em></p>
                            <div className="buttonGroup">
                              <SelectButton selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } tableSelect={ tableSelect } />
                                <a href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2023+FEDERAL+TAX+RATE+SCHEDULE+Final.pdf" target="blank">
                                    <Button type='submit' className='SelectButton'><FontAwesomeIcon icon={faDownload}/> Download PDF</Button>
                                </a>
                              </div>
                            <TaxTable title='Single/Married Filing Separate' data={ Data2023.State.California.Single } hover= { selectedButton.name } />
                            <TaxTable title='Married Filing Joint' data={ Data2023.State.California.Married_Filing_Jointly } hover= { selectedButton.name } />
                            <TaxTable title='Unmarried Head of Household' data={ Data2023.State.California.Unmarried_Head_of_Household } hover= { selectedButton.name } />
                            <StandardDeduction data={ Data2023.State.California.Standard_Deduction } />
                        </TabPanel>
                        <TabPanel>
                            <h1 className='taxYear'>2022 CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                            <p className={`Instructions ${ isMobile }`}><em>The buttons below allow you to select a single cell, row, or the entire table and copy it to your clipboard.</em></p>
                            <div className="buttonGroup">
                                <SelectButton selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } tableSelect={ tableSelect } />
                                <a href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/Desktop+Reference+for+CFTU+2022.pdf" target="blank">
                                    <Button type='submit' className='SelectButton'><FontAwesomeIcon icon={faDownload}/> Download PDF</Button>
                                </a>
                            </div>
                            <TaxTable title='Single/Married Filing Separate' data={ Data2022.State.California.Single } hover= { selectedButton.name } />
                            <TaxTable title='Married Filing Joint' data={ Data2022.State.California.Married_Filing_Jointly } hover= { selectedButton.name } />
                            <TaxTable title='Unmarried Head of Household' data={ Data2022.State.California.Unmarried_Head_of_Household } hover= { selectedButton.name } />
                            <StandardDeduction data={ Data2022.State.California.Standard_Deduction } />
                        </TabPanel>
                        <TabPanel>
                            <h1 className='taxYear'>2021 CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                            <p className={`Instructions ${ isMobile }`}><em>The buttons below allow you to select a single cell, row, or the entire table and copy it to your clipboard.</em></p>
                            <div className="buttonGroup">
                                <SelectButton selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } tableSelect={ tableSelect } />
                                <a href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/Desktop+Reference+for+CFTU+2021+(UPDATED)+(1).pdf" target="blank" className="button">
                                    <Button type='submit' className='SelectButton'><FontAwesomeIcon icon={faDownload}/> Download PDF</Button>
                                </a>
                            </div>
                            <TaxTable title='Single/Married Filing Separate' data={ Data2021.State.California.Single } hover= { selectedButton.name } />
                            <TaxTable title='Married Filing Joint and Surviving Spouse with Dependents' data={ Data2021.State.California.Married_Filing_Joint_and_Surviving_Spouse_with_Dependents } hover= { selectedButton.name } />
                            <TaxTable title='Unmarried Head of Household' data={ Data2021.State.California.Unmarried_Head_of_Household } hover= { selectedButton.name } />
                        </TabPanel>
                        <TabPanel>
                            <h1 className='taxYear'>2020 CALIFORNIA FEDERAL TAX RATE SCHEDULES</h1>
                            <p className={`Instructions ${ isMobile }`}><em>The buttons below allow you to select a single cell, row, or the entire table and copy it to your clipboard.</em></p>
                            <div className="buttonGroup">
                                <SelectButton selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } tableSelect={ tableSelect } />
                            </div>
                            <TaxTable title='Single/Married Filing Separate' data={ Data2020.State.California.Single } hover= { selectedButton.name } />
                            <TaxTable title='Married Filing Joint and Surviving Spouse with Dependents' data={ Data2020.State.California.Married_Filing_Jointly } hover= { selectedButton.name } />
                            <TaxTable title='Unmarried Head of Household' data={ Data2020.State.California.Unmarried_Head_of_Household } hover= { selectedButton.name } />
                        </TabPanel>
                    </Container>
                </Tabs>
            </Container>
        </CaliforniaStyled>
    );

};

export default California;

const CaliforniaStyled = styled.div`
    h1 {
        text-align: center;
        padding-top: 50px;
        color: #ea5151;
    }

    h3 {
        text-align: center;
        color: #ea5151;
    }

    table th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: center;
        background-color: #ea5151;
        color: white;
    }

    .cali-image {
        background-image: url("https://westerncpe.s3.amazonaws.com/tax-app/california.jpg");
        height: 300px;
        width: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-bottom: 3px solid #ea5151;
        h1{
            text-align: center;
            color: white;
            margin: auto;
            padding-top: 125px;
        }
    }

    .full-width-div {}

    .react-tabs__tab-list {
        max-width: 1320px;
        margin: 0 auto;
        border-bottom: none;
        background-color: #f8f9fb;
    }

    .react-tabs__tab--selected {
        border-bottom: 2px solid #ea5151;
        border-top: none;
        border-right: none;
        border-left: none;
    }

    .react-tabs__tab:focus:after {
        background: none;
    }

    .listParent {
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
        background-color: #f8f9fb;
    }

    @media (max-width: 767px) {
        .cali-image {
            height: 15vh;
            h1{
                text-align: center;
                color: white;
                margin: auto;
                padding-top: 30px;
                line-height: 2rem;
            }
        }
    }
`;
